const Logo = () => {
  return <h1 style={{ color: "#0A4D68" }}>Technoverse</h1>;
};

export default Logo;
